import { render, staticRenderFns } from "./SamplesRoom.vue?vue&type=template&id=29684c7e&scoped=true&"
import script from "./SamplesRoom.vue?vue&type=script&lang=js&"
export * from "./SamplesRoom.vue?vue&type=script&lang=js&"
import style0 from "./SamplesRoom.vue?vue&type=style&index=0&id=29684c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29684c7e",
  null
  
)

export default component.exports